import { render, staticRenderFns } from "./intake-variety.vue?vue&type=template&id=62daabe9"
import script from "./intake-variety.vue?vue&type=script&lang=js"
export * from "./intake-variety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports